// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-H1":"H1_vanlife-roadtrips-H1__RxUq2"};